import globals from './Globals';
import loader from './Loader';
import RenderContainer from './RenderContainer';

class TextVisButton extends RenderContainer {
  constructor() {
    super();

    this.name = 'TextVisButton';
    this.imageNameActive = 'text-up';
    this.imageNameInactive = 'text-down';

    this.bitmapActive = null;
    this.bitmapInactive = null;

    loader.addItems(this, [this.imageNameActive, this.imageNameInactive]);
    // loader.addItem(this, this.imageNameInactive);

    this.relX = 0.95;
    this.relY = 0.07;

    const pos = globals.relToScreen({ x: this.relX, y: this.relY });
    this.x = pos.x;
    this.y = pos.y;
    this.maxWidth = 0.12;
    this.maxHeight = 0.12;
    const size = globals.relSizeToScreen({
      x: this.maxWidth,
      y: this.maxHeight
    });
    this.render.stream = false;
    this.width = size.x;
    this.height = size.y;
    this.setBounds(this.x, this.y, this.width, this.height);
    this.render.stream = false;
    this.render.once = true;
    this.isActive = true;

    this.shadow = new createjs.Shadow('#aaaaaa', 0, 3, 4);
  }

  inactive() {
    this.render.once = true;
    this.bitmapActive.visible = false;
    this.bitmapInactive.visible = true;
    this.isActive = false;
  }

  active() {
    this.render.once = true;
    this.bitmapActive.visible = true;
    this.bitmapInactive.visible = false;
    this.isActive = true;
  }

  pressed() {
    if (this.isActive) {
      this.inactive();
    } else {
      this.active();
    }
  }

  loaded() {
    const tag = loader.getItem(this.imageNameActive);
    this.clipImageSizeToSize(tag);
    this.centerOnSelf();

    this.bitmapActive = new createjs.Bitmap(
      loader.getItem(this.imageNameActive)
    );
    this.bitmapInactive = new createjs.Bitmap(
      loader.getItem(this.imageNameInactive)
    );
    this.bitmapActive.visible = true;
    this.bitmapInactive.visible = false;
    this.addChild(this.bitmapInactive);
    this.addChild(this.bitmapActive);
    this.render.once = true;
  }
}

export { TextVisButton as default };
